import { useState } from "react";
import { FormControlLabel, Radio, RadioGroup, TextField } from "@mui/material";

const ResultColumnInbound = ({
  question,
  setTotalScore,
  questionScores,
  setQuestionScores,
}) => {
  const [grade, setGrade] = useState(question.score);
  const [selected, setSelected] = useState(question.choice);

  return (
    <div className="result">
      <TextField
        className="grade"
        inputProps={{ readOnly: true }}
        value={grade}
      />

      <RadioGroup
        row
        value={selected}
        onChange={(e) => {
          let grade,
            tempQuestionScores = questionScores;

          grade = Number(
            question.options?.split("|")[
              question.choices
                ?.split("|")
                .findIndex((choice) => choice === e.target.value)
            ]
          );

          setSelected(e.target.value);
          setGrade(grade);

          tempQuestionScores[
            questionScores.findIndex(
              (questionScore) => questionScore.id === question.scorequestionid
            )
          ].score = grade;

          tempQuestionScores[
            questionScores.findIndex(
              (questionScore) => questionScore.id === question.scorequestionid
            )
          ].choice = e.target.value;

          setTotalScore(
            tempQuestionScores.reduce((accumulator, currentValue) => {
              const score = Number(currentValue.score);
              return accumulator + score;
            }, 0)
          );

          setQuestionScores(tempQuestionScores);
        }}
      >
        {question.choices?.split("|").map((choice, index) => (
          <FormControlLabel
            control={<Radio className="radio" />}
            key={choice}
            label={choice}
            value={choice}
          />
        ))}
      </RadioGroup>
    </div>
  );
};

export default ResultColumnInbound;
